module.exports = __webpack_public_path__ + "img/Rotor_Course_Gauge_Indicator_v01.a45d2230.svg";